export { default } from './accordion';
export type { IAccordionProps } from './types';
